import { createFileRoute } from "@tanstack/react-router";
import { serviceSchemaScripts } from "@/lib/service-schema";
import SeoWebIA from "@/pages/servicios/SeoWebIA";

export const Route = createFileRoute("/servicios/seo-web-ia")({
  head: () => ({
    meta: [
      { name: "twitter:card", content: "summary_large_image" },
      { title: "SEO web para empresas: técnica, contenido y autoridad | SEOEVOLUTION" },
      { name: "description", content: "Posicionamiento orgánico para webs de empresa: auditoría técnica, arquitectura, contenido y autoridad. Estrategia personalizada según mercado y objetivos." },
      { name: "keywords", content: "SEO web, posicionamiento web, SEO con IA, optimización web, tráfico orgánico, SEO automatizado" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/servicios/seo-web-ia" },
      { property: "og:title", content: "SEO web para empresas: técnica, contenido y autoridad | SEOEVOLUTION" },
      { property: "og:description", content: "Posicionamiento orgánico para webs de empresa: auditoría técnica, arquitectura, contenido y autoridad. Estrategia personalizada según mercado y objetivos." },
      { name: "twitter:title", content: "SEO web para empresas: técnica, contenido y autoridad | SEOEVOLUTION" },
      { name: "twitter:description", content: "Posicionamiento orgánico para webs de empresa: auditoría técnica, arquitectura, contenido y autoridad. Estrategia personalizada según mercado y objetivos." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/servicios/seo-web-ia" }],
    scripts: serviceSchemaScripts("seo-web-ia"),
  }),
  component: SeoWebIA,
});
